import React from "react";

function CardDetails({ name, value, image, Svg }) {
  return (
    <div className=" min-w-[198px] h-full px-4 flex items-center sm:flex-col md:flex-row">
      <img
        src={Svg ? Svg : image}
        alt="consent"
        width={Svg ? 43 : 53}
        height={Svg ? 43 : 53}
      />

      <div className=" ml-4 flex flex-col h-[57px] justify-between font-semibold ">
        <p className=" lg:text-sm md:text-xs text-[#848484]">{name}</p>
        <p className=" lg:text-2xl md:text-sm">{value}</p>
      </div>
    </div>
  );
}

export default CardDetails;
